import styled from 'styled-components'

export const WorkOrderRoot = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  width: 100%;
  background: var(--card);
`
export const WorkOrderToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 3.25rem 0.625rem 0.75rem;
  border-bottom: 1px solid var(--border);
`
export const WorkOrderTitle = styled.div`
  flex: 1;
  min-width: 6rem;
  font-size: 0.8125rem;
  font-weight: 600;
  span {
    display: block;
    font-size: 0.6875rem;
    font-weight: 400;
    color: var(--muted-foreground);
  }
`
export const WorkOrderCanvas = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
`
export const WorkOrderNotice = styled.div`
  padding: 0.625rem 0.75rem;
  font-size: 0.75rem;
  border-bottom: 1px solid var(--border);
  color: var(--muted-foreground);
`
export const WorkOrderSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--border);
  input {
    flex: 1;
    min-width: 3rem;
  }
`
export const WorkOrderEmpty = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  text-align: center;
`
export const WorkOrderPageStatus = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
`
export const WorkOrderFullscreen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: var(--muted);
  overflow: hidden;
`
